import { cn } from "@/lib/utils";

interface PlusBadgeProps {
  size?: "sm" | "md";
  className?: string;
}

export function PlusBadge({ size = "sm", className }: PlusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-semibold",
        "bg-gradient-to-r from-primary to-accent text-primary-foreground",
        size === "sm" && "px-2 py-0.5 text-[10px]",
        size === "md" && "px-3 py-1 text-xs",
        className
      )}
    >
      🐊 Plus
    </span>
  );
}

export function CreatorOfMonthBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold",
        "bg-accent text-accent-foreground",
        className
      )}
    >
      🏆 Creator of the Month
    </span>
  );
}
